export default __webpack_public_path__ + "static/media/problema-10.df638f7d.webp";